import { ChakraProvider } from '@chakra-ui/react'
import { AppRoutes } from './routes'
import { BrowserRouter } from 'react-router-dom'
import FontStyles from './pages/Vendas/CadastroOrcamento/styles'
import { theme } from './services/ThemeProvider'
import { ProductProvider } from './pages/Vendas/CadastroOrcamento/contexts/ProductProvider'
import { ContasReceberProvider } from './pages/Financeiro/ContasReceber/contexts/ContasReceberProvider'
import { EditConfirmacaoCompraProvider } from './contexts/EditConfirmacaoCompraProvider'
import { KanguCargobrProvider } from './contexts/KanguCargobrContext'
import { QueryClientProvider } from 'react-query'
import { queryClient } from './services/queryClient'
import { ReactQueryDevtools } from 'react-query/devtools'

import { AuthenticationProvider } from './contexts/AuthenticationProvider'
import { CallPhoneProvider } from './contexts/CallPhoneContext'
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { PermissoesTelas } from './middlewares/permissoesTelas'

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <CallPhoneProvider>
          <AuthenticationProvider>
            <QueryClientProvider client={queryClient}>
              <KanguCargobrProvider>
                <EditConfirmacaoCompraProvider>
                  <ContasReceberProvider>
                    <ProductProvider>
                      <ChakraProvider theme={theme}>
                        <FontStyles />

                        <PermissoesTelas />

                        <AppRoutes />
                        <ReactQueryDevtools initialIsOpen={false} />
                      </ChakraProvider>
                    </ProductProvider>
                  </ContasReceberProvider>
                </EditConfirmacaoCompraProvider>
              </KanguCargobrProvider>
            </QueryClientProvider>
          </AuthenticationProvider>
        </CallPhoneProvider>
      </Provider>
    </BrowserRouter>
  )
}

export default App
